import * as React from "react";

import { useGetSvgIconFill } from "@intelligems/ig-theme/hooks/use-get-svg-icon-fill";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const Visibility = (props: SvgIconProps) => {
  const fill = useGetSvgIconFill(props.color);

  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={35}
        height={35}
        fill="none"
        viewBox="0 0 35 35"
        {...props}
      >
        <rect width={35} height={35} fill="#fff" rx={5} />
        <rect width={35} height={35} fill={fill} fillOpacity={0.08} rx={5} />
        <path
          fill={fill}
          fillOpacity={0.38}
          d="M17.5 22q1.875 0 3.188-1.312Q22 19.375 22 17.5t-1.312-3.187T17.5 13t-3.187 1.313T13 17.5t1.313 3.188T17.5 22m0-1.8q-1.125 0-1.912-.787A2.6 2.6 0 0 1 14.8 17.5q0-1.125.787-1.912A2.6 2.6 0 0 1 17.5 14.8q1.125 0 1.913.787.787.788.787 1.913t-.787 1.913a2.6 2.6 0 0 1-1.913.787m0 4.8q-3.65 0-6.65-2.038T6.5 17.5q1.35-3.425 4.35-5.462T17.5 10t6.65 2.037T28.5 17.5q-1.35 3.425-4.35 5.462T17.5 25m0-2a9.54 9.54 0 0 0 5.188-1.488A9.77 9.77 0 0 0 26.3 17.5a9.77 9.77 0 0 0-3.613-4.012A9.54 9.54 0 0 0 17.5 12a9.54 9.54 0 0 0-5.187 1.488A9.77 9.77 0 0 0 8.7 17.5a9.77 9.77 0 0 0 3.613 4.012A9.54 9.54 0 0 0 17.5 23"
        />
      </svg>
    </SvgIcon>
  );
};
